export enum Component{
    Autocomplete = 'autocomplete',
    Checkbox = 'checkbox',
    Content = 'content',
    Date = 'date',
    Email = 'email',
    FileUpload = 'file_upload',
    Number = 'number',
    Range = 'range',
    PayPal = 'paypal',
    Radio = 'radio',
    Select = 'select',
    Text = 'text',
    Phone = 'phone',
    TextArea = 'textarea',
    Time = 'time',
    Unique = 'unique',
    Formula = 'formula',
    Signature = 'signature',
    Summary = 'summary',
    Columns = 'columns',
    Rating = 'rating',
}
